import React, { Fragment, PureComponent } from "react";
import axios from "axios";
import { server, config, checkAccess } from "../../env";
import Header from "../../components/Header";
import Alert from "../../components/Alert";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal";
import { Link } from "react-router-dom";
import TopCard from "../DashboardComponents/StatsTopCard";

export default class Datacenter extends PureComponent {
  state = {
    dashData: {},
    have_plan: false,
    plan_data: [],
    user_data: [],
    usage_stats: [],
    isPendingPlan: false,
    allPlans: [],
    ipAmount: 0,
    loader: "",

    message: "",
    copyButton: "Copy",
    proxies: "",
    data: [],

    ips: [],

    // change plan name
    planNameLoader: "",
  };

  componentDidMount = () => {
    document.title = "Datacenter Proxies - Proxies.gg";
    this.readDataStats();
    // this.readIps();
  };

  readDataStats = async () => {
    await axios
      .get(server + "/v1/user/dashboard", config)
      .then((rsp) => {
        // const proxies = [];
        // for (let i = 8603; i <= 8902; i++) {
        //   proxies.push("datacenter.proxies.gg:" + i);
        // }
        const data = rsp.data.payload.PR_4;
        this.setState({
          have_plan: data.have_plan,
          plan_data: data.plan_data.length > 0 ? data.plan_data[0] : {},
          allPlans: data.plan_data,
          ips: data.plan_data.length > 0 ? data.plan_data[0].activeIps : [],
          // proxies: data.have_plan ? proxies : "",
          proxies: data.have_plan ? data.proxies : "",
          ipAmount: data.ipAmount,
          user_data: data.user_data,
          usage_stats: data.usage_stats,
          isPendingPlan: data.isPendingPlan,
        });
      })
      .catch((err) => {
        checkAccess(err);
      });
  };

  readIps = () => {
    axios
      .get(`${server}/v1/user/get-whitelisted-ip?type=PR_4`, config)
      .then((res) => {
        this.setState({
          ips: res.data.payload,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  deleteIP = (id) => {
    axios
      .delete(`${server}/v1/user/delete-whitelist-ip/${id}`, config)
      .then((res) => {
        this.readIps();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  copyCodeToClipboard = () => {
    const el = this.textArea;
    el.select();
    document.execCommand("copy");
    this.setState({ copyButton: "Copied" });
  };

  activatePlan = (e) => {
    e.preventDefault();

    this.setState({
      loader: <Loader />,
    });

    const params = {
      ips: e.target.ips.value,
      type: "PR_4",
    };

    axios
      .post(server + "/v1/user/activate-dc-ipv6-plan", params, config)
      .then((rsp) => {
        this.setState({
          loader: "",
          message: <Alert message={rsp.data.detail} className="success" />,
        });
        this.readDataStats();
        // this.readIps();
      })
      .catch((err) => {
        console.log(err);
        checkAccess(err);
        if (err.response) {
          this.setState({
            loader: "",
            message: (
              <Alert message={err.response.data.detail} className="danger" />
            ),
          });
        }
      });
  };

  whitelistIP = (e) => {
    e.preventDefault();

    this.setState({
      loader: <Loader />,
    });

    const params = {
      ip: e.target.ips.value,
      plan: this.state.plan_data ? this.state.plan_data.id : "",
    };

    axios
      .post(server + "/v1/user/whitelist-ip-dc", params, config)
      .then((rsp) => {
        this.setState({
          loader: "",
          message: <Alert message={rsp.data.detail} className="success" />,
        });
      })
      .catch((err) => {
        checkAccess(err);
        if (err.response) {
          this.setState({
            loader: "",
            message: (
              <Alert message={err.response.data.detail} className="danger" />
            ),
          });
        }
      });
    this.readDataStats();
  };

  changePlan = (e) => {
    const newPlan =
      this.state.allPlans.find(
        (plan) => plan.id === parseInt(e.target.value)
      ) || {};
    this.setState({
      plan_data: newPlan,
      ips: newPlan ? newPlan.activeIps : [],
    });
  };

  onChangePlanName = (e) => {
    this.setState({
      plan_data: {
        ...this.state.plan_data,
        planName: e.target.value,
      },
    });
  };

  changePlanName = async (e) => {
    e.preventDefault();

    this.setState({
      planNameLoader: <Loader />,
    });

    const params = {
      id: e.target.plan.value,
      planName: e.target.planName.value,
    };

    await axios
      .post(server + "/v1/user/change-plan-name", params, config)
      .then((rsp) => {
        this.setState({
          planNameLoader: "d",
        });
      })
      .catch((err) => {});

    setTimeout(() => {
      this.setState({
        planNameLoader: "",
      });
    }, 2000);

    this.readDataStats();
  };

  render() {
    const { proxies, loader, copyButton, message, ips } = this.state;
    const { have_plan, plan_data, allPlans } = this.state;
    const { isPendingPlan, planNameLoader } = this.state;

    return (
      <Fragment>
        <div className="main-content">
          <Header pretitle="Dashboard" title="Datacenter Proxies" />
          <div className="container-fluid">
            <div className="row justify-content-between">
              <div className="col-auto">
                {allPlans.length > 0 && (
                  <Fragment>
                    <form onSubmit={this.changePlanName}>
                      <div className="form-group d-inline-block me-3">
                        <select
                          name="plan"
                          id=""
                          className="form-control border pe-3"
                          onChange={this.changePlan}
                        >
                          {allPlans.map((plan, index) => (
                            <option value={plan.id} key={plan.id}>
                              {plan.planName || "Plan" + (index + 1)}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group d-inline-block me-3">
                        <input
                          type="text"
                          name="planName"
                          id="planName"
                          className="form-control border"
                          value={plan_data.planName}
                          onChange={this.onChangePlanName}
                          placeholder="Set Plan Name"
                        />
                      </div>
                      <div className="form-group d-inline-block">
                        <button className="btn btn-primary">
                          Save{planNameLoader}
                        </button>
                      </div>
                    </form>
                  </Fragment>
                )}
              </div>
              <div className="col-auto mb-4">
                <div
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#whitelistIP"
                  onClick={() =>
                    this.setState({
                      message: "",
                    })
                  }
                >
                  Whitelist IPs
                </div>
              </div>
            </div>

            {/* Dashboard stats and activate plans and whitelist ip */}
            <Fragment>
              {isPendingPlan ? (
                <div
                  className="alert alert-primary alert-dismissible fade show"
                  role="alert"
                >
                  <strong>Activate Plan!</strong> Your account having a plan to
                  activate click here to{" "}
                  <Link
                    to="#"
                    className="text-white text-decoration-underline"
                    data-bs-toggle="modal"
                    data-bs-target="#activatePlan"
                    onClick={() =>
                      this.setState({
                        message: "",
                      })
                    }
                  >
                    Activate
                  </Link>
                </div>
              ) : (
                ""
              )}
              <div className="row">
                <TopCard
                  title="Active Plan"
                  value={have_plan ? plan_data.invoice.plan_name : "N/A"}
                  icon="fe-box"
                />
                <TopCard
                  title="IP Whitelisted"
                  value={
                    have_plan
                      ? ips.length + "/" + plan_data?.invoice?.ipAmount
                      : "N/A"
                  }
                  icon="fe-hard-drive"
                />
                <TopCard
                  title="Renew Date"
                  value={
                    have_plan
                      ? new Date(plan_data.expiry_date)
                          .toLocaleString()
                          .split(":")
                          .splice(0, 2)
                          .join(":")
                      : "N/A"
                  }
                  icon="fe-calendar"
                />
              </div>

              {/* Activate Plan */}
              <Modal id="activatePlan" title="Activate Plan">
                <div className="modal-body">
                  <form onSubmit={this.activatePlan}>
                    {message}
                    <div className="form-group">
                      <label htmlFor="">Whitelist IP</label>
                      <input
                        type="text"
                        name="ips"
                        id="ips"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group text-end">
                      <button type="submit" className="btn btn-primary">
                        Activate {loader}
                      </button>
                    </div>
                  </form>
                </div>
              </Modal>

              {/* Whitelist IP */}
              <Modal id="whitelistIP" title="Whitelist IP">
                <div className="modal-body">
                  <form onSubmit={this.whitelistIP}>
                    {message}
                    <div className="form-group">
                      <label htmlFor="">Whitelist IP</label>
                      <input
                        type="text"
                        name="ips"
                        id="ips"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group text-end">
                      <button type="submit" className="btn btn-primary">
                        Whitelist IP {loader}
                      </button>
                    </div>
                  </form>
                </div>
              </Modal>
            </Fragment>

            <div className="row">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-header-title">Whitelisted IPs</h4>
                  </div>
                  <div className="card-body pb-0">
                    <div className="table-responsive">
                      <table className="table table-hover table-nowrap">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>IP</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ips.map((ip, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{ip.ip}</td>
                              <td>
                                <button
                                  className="btn btn-danger rounded btn-sm"
                                  onClick={() => this.deleteIP(ip.id)}
                                >
                                  <i className="fe fe-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-header-title">Your proxies are here</h4>
                    <small>Proxytype: HTTP</small>
                  </div>
                  <div className="card-body pb-0">
                    <div className="form-group">
                      <textarea
                        name="proxies"
                        id="proxies"
                        cols="30"
                        rows="10"
                        className="form-control"
                        value={proxies}
                        ref={(textarea) => (this.textArea = textarea)}
                      ></textarea>
                    </div>
                    <div className="form-group">
                      <button
                        onClick={this.copyCodeToClipboard}
                        type="button"
                        className="btn btn-primary waves-effect waves-light "
                        id="alertify-success"
                      >
                        {copyButton}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
